import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "react-bootstrap";
import { default as Alert } from "./index";
import Button from "../button";
import CustomModal from "../customModal";

interface AlertModalProps {
  notDismissable?: boolean;
  level?: string;
  alertMessage?: string | React.ReactNode;
  modalTitle?: string;
  modalContent?: React.ReactNode;
  buttonAction?: () => void;
  buttonLabel?: string;
  [key: string]: any;
}

export interface AlertModalRef {
  setShowModal: (show: boolean) => void;
}

const AlertModal = forwardRef<AlertModalRef, AlertModalProps>(
  (
    {
      notDismissable,
      level = "info",
      alertMessage,
      modalTitle,
      modalContent,
      buttonAction,
      buttonLabel,
      ...props
    },
    ref
  ) => {
    const [showModal, setShowModal] = useState(false);

    useImperativeHandle(ref, () => ({
      setShowModal,
    }));

    return (
      <>
        <Alert
          notDismissable={notDismissable}
          level={level}
          message={alertMessage}
        />

        <CustomModal
          show={showModal}
          header={modalTitle}
          onHide={() => setShowModal(false)}
          size="lg"
          {...props}
        >
          {modalContent}

          {buttonAction && (
            <Modal.Footer>
              <Button variant="primary" centered onClick={buttonAction}>
                {buttonLabel}
              </Button>
            </Modal.Footer>
          )}
        </CustomModal>
      </>
    );
  }
);

export default AlertModal;
